import type { SocialProfileNetworkType } from '@/types/socialProfileType';

import { THREADS, X } from '@/lib/socialProfile';

export const RESTRICTED_NETWORKS: SocialProfileNetworkType[] = [THREADS];

// X profiles are excluded from group analytics calculations but supported elsewhere (e.g. scheduler labels)
export const GROUP_ANALYTICS_RESTRICTED_NETWORKS: SocialProfileNetworkType[] = [X, THREADS];
